<template>
  <div class="the-navbar__user-meta flex items-center" v-if="userInfo.fullName">
    <!-- <vs-switch v-model="darkModeModel" />
    <span class="ml-2">Chế độ tối</span> -->
    <div class="text-right leading-tight hidden sm:block max-content">
      <div class="component inline-flex mb-1">
        <p class="font-semibold mr-2 m-auto full-name">{{ userInfo.fullName }}</p>
<!--        <package-name></package-name>-->
        <!-- <span class="badge" :style="{background: '#27AE60', color: `white`}">plus</span> -->
      </div>
      <p class="font-email">{{ userInfo.email }}</p>
      <!--<small>Available</small>-->
    </div>
    <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">

      <div class="con-img ml-3">
        <img @error="imgError" v-if="userInfo.photoURL" key="onlineImg" :src="userInfo.img || userInfo.photoURL" alt="user-img" width="40" height="40" class="rounded-full shadow-md cursor-pointer block" />
      </div>

      <vs-dropdown-menu class="vx-navbar-dropdown">
        <ul style="min-width: 9rem">

          <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
              @click="$router.push('/user/user-info').catch(() => {})">
            <feather-icon icon="UserIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">{{$t('userView.infomation')}}</span>
          </li>

          <vs-divider class="m-1" />

          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="logout">
            <feather-icon icon="LogOutIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">{{$t('userView.logOut')}}</span>
          </li>
        </ul>
      </vs-dropdown-menu>
    </vs-dropdown>
  </div>
</template>

<script>
// import PackageName from './PackageName.vue'
import NoImage from '@/assets/images/portrait/small/user-avatar.png';
export default {
  components:{
    // PackageName
  },
  data() {
    return {
      userInfo: {
        img:null
      }
    }
  },
  watch: {
    '$store.state.userInformation'(val) {
      if(!this.userInfo.id) {
        this.userInfo = Object.assign({}, this.$store.state.AppActiveUser, val);
      }
    },
  },
  async created() {
    this.userInfo = Object.assign({}, this.$store.state.AppActiveUser, JSON.parse(localStorage.getItem('userInfo')));
    const data = localStorage.getItem('userInfo');
    const info = JSON.parse(data);
    if(info.img){
      this.userInfo.img = info.img;
    }
  },
  computed : {
    darkModeModel: {
      get()    { return this.$store.state.theme == "dark" },
      set(val) {
        let themeMode = val == true ? 'dark' : 'light';
        localStorage.setItem('themeMode', themeMode);
        this.$store.dispatch('updateTheme', themeMode);
      }
    }

  },
  methods: {
    imgError(image) {
      image.target.src = NoImage;
    },
    logout() {
      if (localStorage.getItem("deviceToken")) {
        this.$business.post('/notification/unsubscribe', {tokens: [localStorage.getItem("deviceToken")]}).then(() => {
          this.$vs.loading.close();
        }).catch(() => {
          this.$vs.loading.close();
        }).finally(()=>{
          localStorage.removeItem("access_token");
          localStorage.removeItem("userInfo");
          location.reload();
        });
      } else {
        localStorage.removeItem("access_token");
        localStorage.removeItem("userInfo");
        location.reload();
      }
    },
  }
}
</script>
<style scoped>
.max-content{
  width: max-content;
}
.font-email{
  color: rgb(185, 185, 195);
  font-size: 12px;
}
.badge {
    padding: .3rem .5rem;
    text-align: center;
    border-radius: .358rem;
    font-weight: 400 !important;
}
.full-name {
  color: #6E6B7B !important;
}
</style>
